/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    'use strict';

    export class DualListMover implements angular.IDirective {
        restrict = 'E';
        templateUrl = "app/components/controls/dualListMoverTemplate.html";
        scope = {
            itemTemplate: "@?",
            leftItems: "=",
            rightItems: "=",
            leftContentKey: "@",
            rightContentKey: "@",
            leftRequired: "=",
            rightRequired: "=",
            onChange: "&",
            disabled: "=",
            itemDisplayProperty: "@?",
            orderBy: "@?",
            enableFilterLeft: "=?",
            enableFilterRight:"=?"
        };

        constructor() {
        }

        link = (scope: any, element: JQuery, attr: angular.IAttributes) => {
            if (!scope.itemTemplate) {
                scope.itemTemplate = "app/components/controls/dualListMoverDefaultItem.html";
            }
            scope.selectedItems = [];
            scope.deselectedItems = [];
            var leftfilter;
            var rightfilter;

            scope.selectLeftItem = (item) => {
                if (scope.disabled) return;
                if (!item.selected) {
                    item.selected = true;
                    scope.selectedItems.push(item);
                } else {
                    item.selected = false;
                    var index = scope.selectedItems.indexOf(item);
                    scope.selectedItems.splice(index, 1);
                }
            }

            scope.selectRightItem = (item) => {
                if (scope.disabled) return;
                if (!item.selected) {
                    item.selected = true;
                    scope.deselectedItems.push(item);
                } else {
                    item.selected = false;
                    var index = scope.deselectedItems.indexOf(item);
                    scope.deselectedItems.splice(index, 1);
                }
            }

            scope.selectAll = () => {
                if (scope.disabled) return;
                _.each(scope.selectedItems, (item: any) => { delete item.selected });
                scope.rightItems = _.union(scope.leftItems, scope.rightItems);
                scope.leftItems = [];
            };
            scope.unselectAll = () => {
                if (scope.disabled) return;
                _.each(scope.deselectedItems, (item: any) => { delete item.selected });
                scope.leftItems = _.union(scope.leftItems, scope.rightItems);
                scope.rightItems = [];
            };
            scope.addSelected = () => {
                if (scope.disabled) return;
                _.each(scope.selectedItems, (item:any) => {delete item.selected});
                scope.leftItems = _.difference(scope.leftItems, scope.selectedItems);
                scope.rightItems = _.union(scope.rightItems, scope.selectedItems);
                scope.selectedItems = [];
            };
            scope.removeSelected = () => {
                if (scope.disabled) return;
                _.each(scope.deselectedItems, (item:any) => { delete item.selected });
                scope.rightItems = _.difference(scope.rightItems, scope.deselectedItems);
                scope.leftItems = _.union(scope.leftItems, scope.deselectedItems);
                scope.deselectedItems = [];
            };

            scope.$watch('leftItems', () => {
                scope.selectedItems = [];
            });
            scope.$watch('rightItems', () => {
                scope.deselectedItems = [];
            });
        };

        static factory(): angular.IDirectiveFactory {
            return () => {
                return new DualListMover();
            };
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoDualListMover', DualListMover.factory());
}